import { render, staticRenderFns } from "./echart-pie-simple.vue?vue&type=template&id=6cdb475e&"
import script from "./echart-pie-simple.vue?vue&type=script&lang=js&"
export * from "./echart-pie-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports